export default {
    BY_POLICY: 'byPolicyNumber',
    BY_SUBMISSION: 'bySubmissionNumber',
    BY_FRSTLAST: 'byFirstLastName',
    BY_COMPANY: 'byCompanyName',
    SEARCH_TYPE_POLICY: 'Policy',
    SEARCH_TYPE_SUBMISSION: 'Submission',
    SEARCH_BY: 'searchBy'
};
